module.exports = __webpack_public_path__ + "img/button_language_uk.af5bcd88.svg";